import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
// Style
import './FormData.css';

const FormData = ({ setLogo, logo }) => {
	const [errorLogo, setErrorLogo] = useState('');

	// Función de aceptación de tipo de imagen
	const onDrop = (acceptedFiles) => {
		const file = acceptedFiles[0];

		if (!file) {
			setLogo(null);
			return;
		}

		// Validar el tipo de archivo
		if (file.type !== 'image/png') {
			setLogo(null);
			setErrorLogo('El archivo debe ser un .png');
			return;
		}

		// Validar el tamaño del archivo
		if (file.size > 500 * 1024) {
			// 1MB
			setLogo(null);
			setErrorLogo('El archivo no debe exceder 500kb');
			return;
		}

		// Leer el archivo para obtener las dimensiones de la imagen
		const reader = new FileReader();
		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				if (img.width > 500 || img.height > 500) {
					setLogo(null);
					setErrorLogo('La imagen debe ser menor a 500px x 500px');
				} else {
					setLogo(file);
					setErrorLogo('');
				}
			};
			img.src = e.target.result;
		};
		reader.readAsDataURL(file);
	};

	return (
		<Dropzone onDrop={onDrop}>
			{({ getRootProps, getInputProps }) => (
				<div {...getRootProps()} className='dropForm'>
					<input {...getInputProps()} />
					{logo ? (
						<p style={{ color: 'green' }}>
							<b>Imagen cargada con éxito:</b> {logo.name}
						</p>
					) : (
						<p>
							Arrastre el archivo o haz clic aquí para seleccionar el logo de la
							institución
						</p>
					)}
					{errorLogo && <p style={{ color: 'red' }}>{errorLogo}</p>}
				</div>
			)}
		</Dropzone>
	);
};

export default FormData;
